<div class="flex-row-split height100p">
    <p-panel class="flex-item-fixed width300 full-height" header="Optionen">
        <sm-form  [form]="formSearch">
        </sm-form>
        <p-button icon="fas fa-search" label="Suchen" (onClick)="search()"></p-button>
    </p-panel>
    <div *ngIf="table != null" class="flex-item-fill flex-col">
        <sm-table2 [data]="table" class="flex-item-fill height100p"></sm-table2>
        <div class="mt-2">
            Anzahl gefundener Einträge: {{table.rows.length}}
        </div>
    </div>
</div>
